import { SupportFormContainter } from "./supportElements";
import {
  FormControl,
  FormLabel,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import { ButtonDark } from "../button/buttonElements";
import { useFormik } from "formik";
import { SendSalesMessage } from "../../services/ProtectedService";
import * as Yup from "yup";
import SweetAlert from "react-bootstrap-sweetalert";
import { useState } from "react";

const SalesSupportForm = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      designation: "",
      email: "",
      phoneNumber: "",
      companyName: "",
      companyWebsite: "",
      message: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Required"),
      lastName: Yup.string().required("Required"),
      designation: Yup.string().required("Required"),
      email: Yup.string().email("Invalid email address").required("Required"),
      phoneNumber: Yup.string().min(8, "Invalid phone number").notRequired(),
      companyName: Yup.string()
        .min(5, "Must be at least 5 characters long")
        .required("Required"),
      companyWebsite: Yup.string()
        .url("string must be a valid url")
        .required("Required"),
      message: Yup.string()
        .min(10, "Must be at least 10 characters long")
        .required("Required"),
    }),
    onSubmit: async (values) => {
      const response = await SendSalesMessage(values);
      if (response.status === 200) {
        setModalOpen(true);
        formik.resetForm();
      } else setErrorModal(true);
    },
  });

  const closeModal = () => {
    setModalOpen(false);
    setErrorModal(false);
  };

  return (
    <SupportFormContainter>
      <Paper>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2} className="supportForm">
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel htmlFor="firstName">First name</FormLabel>
                <TextField
                  variant="outlined"
                  id="firstName"
                  type="text"
                  placeholder="Michelangelo Lodovico"
                  {...formik.getFieldProps("firstName")}
                />
                {formik.errors.firstName && formik.touched.firstName ? (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      paddingTop: "4px",
                    }}
                  >
                    {formik.errors.firstName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel htmlFor="lastName">Last name</FormLabel>
                <TextField
                  variant="outlined"
                  id="lastName"
                  type="text"
                  placeholder="Lodovico"
                  {...formik.getFieldProps("lastName")}
                />
                {formik.errors.lastName && formik.touched.lastName ? (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      paddingTop: "4px",
                    }}
                  >
                    {formik.errors.lastName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel htmlFor="desgnation">Designation</FormLabel>
                <Select
                  labelId="designation"
                  {...formik.getFieldProps("designation")}
                  displayEmpty
                  s
                >
                  <MenuItem value="">Select one...</MenuItem>
                  <MenuItem value="Founder">Founder</MenuItem>
                  <MenuItem value="Director">Director</MenuItem>
                  <MenuItem value="IT Head">IT Head</MenuItem>
                  <MenuItem value="Manager">Manager</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
                {formik.errors.lastName && formik.touched.lastName ? (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      paddingTop: "4px",
                    }}
                  >
                    {formik.errors.lastName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel htmlFor="email">Email</FormLabel>
                <TextField
                  variant="outlined"
                  type="email"
                  placeholder="michelangelo@mail.com"
                  {...formik.getFieldProps("email")}
                />
                {formik.errors.email && formik.touched.email ? (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      paddingTop: "4px",
                    }}
                  >
                    {formik.errors.email}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel htmlFor="phoneNumber">Phone Number</FormLabel>
                <TextField
                  variant="outlined"
                  type="tel"
                  id="phoneNumber"
                  placeholder="+234 778 3882 990"
                  {...formik.getFieldProps("phoneNumber")}
                />
                {formik.errors.phoneNumber && formik.touched.phoneNumber ? (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      paddingTop: "4px",
                    }}
                  >
                    {formik.errors.phoneNumber}
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel htmlFor="companyName">Company Name</FormLabel>
                <TextField
                  variant="outlined"
                  type="tel"
                  id="companyName"
                  placeholder="Lorem Corp. Limited"
                  {...formik.getFieldProps("companyName")}
                />
                {formik.errors.companyName && formik.touched.companyName ? (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      paddingTop: "4px",
                    }}
                  >
                    {formik.errors.companyName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel htmlFor="companyWebsite">Company Website</FormLabel>
                <TextField
                  variant="outlined"
                  type="tel"
                  id="companyWebsite"
                  placeholder="loremcorp.com"
                  {...formik.getFieldProps("companyWebsite")}
                />
                {formik.errors.companyWebsite &&
                formik.touched.companyWebsite ? (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      paddingTop: "4px",
                    }}
                  >
                    {formik.errors.companyWebsite}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <FormLabel htmlFor="message">
                  Tell us about your needs
                </FormLabel>
                <TextField
                  variant="outlined"
                  type="textarea"
                  placeholder="What are your needs today..."
                  id="message"
                  multiline
                  rows={3}
                  {...formik.getFieldProps("message")}
                />
                {formik.errors.message && formik.touched.message ? (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      paddingTop: "4px",
                    }}
                  >
                    {formik.errors.message}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <ButtonDark type="submit" disabled={formik.isSubmitting}>
                Send your message
              </ButtonDark>
            </Grid>
          </Grid>
        </form>
        <SweetAlert
          show={modalOpen}
          success
          title="Message sent!"
          onConfirm={closeModal}
          confirmBtnText="Close"
          confirmBtnStyle={{
            padding: "8px 20px",
            backgroundColor: "green",
            borderRadius: "4px",
            color: "whitesmoke",
          }}
        >
          We will reach out to you soon
        </SweetAlert>
        <SweetAlert
          show={errorModal}
          error
          title="Oops!"
          onConfirm={closeModal}
          confirmBtnText="Close"
          confirmBtnStyle={{
            padding: "8px 20px",
            backgroundColor: "red",
            borderRadius: "4px",
            color: "whitesmoke",
          }}
          confirmBtnBsStyle="danger"
        >
          Something went wrong. Try again!
        </SweetAlert>
      </Paper>
    </SupportFormContainter>
  );
};

export default SalesSupportForm;
